<ng-container *ngIf="(screenSizeService.isHandset$ | async) === false; else handsetTemplate">
  <app-horizontal-navigation *ngLet=" (dprDetails$ | async) as dprDetails">
    <ng-container
      *ngIf="((selectedSubproject$ | async)?.data?.activityStreams |  filterActivityStreamsForDisplay : dprDetails?.dprActivities : dprDetails?.dprParallelActivities) as activityStreams "
    >
      <div class="customHorizontalNavContainer">
        <button
          *ngFor="let item of activityStreams; trackBy: trackActivityStream"
          mat-flat-button
          class="mr-2 horizontalNavButton text-transform-initial"
          routerLinkActive="mat-secondary"
          [routerLink]="[item.id]"
          (click)="changePreselectedActivityStreamId(item.id)"
          [attr.data-testId]="item.value"
        >
          {{item.value}}
        </button>
      </div>
    </ng-container>
  </app-horizontal-navigation>
</ng-container>

<router-outlet (activate)="componentActivated($event)" (deactivate)="componentDeactivated()"></router-outlet>

<ng-template #handsetTemplate>
  <ng-container *ngLet=" (dprDetails$ | async) as dprDetails">
    <ng-container
      *ngIf="dprDetails && ((selectedSubproject$ | async)?.data?.activityStreams |  filterActivityStreamsForDisplay : dprDetails?.dprActivities : dprDetails?.dprParallelActivities) as activityStreams "
    >
      <app-navigation-select
        [items]="activityStreams | mapNavigationMenuItem : 'id' : 'value' : 'id'"
        [initialSelection]="preselectedActivityStreamId"
        (selectedItemChanges)="changePreselectedActivityStreamId(+($event))"
      ></app-navigation-select>
    </ng-container>
  </ng-container>
</ng-template>
